import React from "react";
import styled from "styled-components";
import ApplicationOne from "./ApplicationOne";
import XRuler from "../molecules/XRuler";
import YRuler from "../molecules/YRuler";

const Holder = styled.div`
  position: sticky;
  top: 5rem;
  max-width: calc(100vh - 5rem); // making sure the pattern is not larger than the fold
  margin: 0 auto;
  display: grid;
  grid-template-columns: 5rem 1fr;
  grid-template-rows: 5rem 1fr;
  justify-items: start;
  padding-right: 3rem;
  padding-bottom: 2rem;
`;

const Main = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 100%;

  .inner {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
`;

function ApplicationOneHolder() {
  return (
    <Holder>
      <div />
      <XRuler />
      <YRuler />
      <Main>
        <div className="inner">
          <ApplicationOne />
        </div>
      </Main>
    </Holder>
  );
}

export default ApplicationOneHolder;
